"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("./index"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'PieChart',
  components: {
    echartsNew: _index.default
  },
  props: {
    // 图表标题
    title: {
      type: String,
      default: ''
    },
    // 图表数据 { '名称1': 值1, '名称2': 值2 }
    chartData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 颜色映射 { '名称1': '#颜色1', '名称2': '#颜色2' }
    colorMap: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 颜色列表
    colorList: {
      type: Array,
      default: function _default() {
        return ['#1890ff', '#fa8c16', '#e6a23c', '#52c41a', '#A277FF'];
      }
    },
    // 图表高度
    height: {
      type: String,
      default: '400px'
    },
    // 图表宽度
    width: {
      type: String,
      default: '100%'
    },
    // 图例位置配置
    legend: {
      type: Object,
      default: function _default() {
        var _this = this;
        return {
          orient: 'vertical',
          right: 10,
          top: 'center',
          formatter: function formatter(name) {
            var info = _this.chartData;
            var total = _this.dataTotal;
            var value = info[name];
            var pValue = total == 0 ? 0 : (value / total * 100).toFixed(2);
            return "".concat(name, ": ").concat(value, "\u4EBA (").concat(pValue, "%)");
          }
        };
      }
      // default: () => ({
      //   orient: 'vertical',
      //   right: 10,
      //   top: 'center',
      //   formatter: '{name}: {c}人 ({d}%)'
      // })
    },
    // 数据系列名称
    seriesName: {
      type: String,
      default: '数据统计'
    },
    // 饼图半径
    radius: {
      type: Array,
      default: function _default() {
        return ['40%', '70%'];
      }
    },
    // 饼图中心位置
    center: {
      type: Array,
      default: function _default() {
        return ['35%', '50%'];
      }
    },
    // 是否显示扇区标签
    showLabel: {
      type: Boolean,
      default: true
    },
    // 扇区标签位置
    labelPosition: {
      type: String,
      default: 'outside'
    },
    // 扇区标签格式化
    labelFormatter: {
      type: String,
      default: '{b}: {d}%'
    },
    // 扇区标签样式
    labelStyle: {
      type: Object,
      default: function _default() {
        return {
          fontSize: '12px',
          color: '#303133'
        };
      }
    },
    // 是否显示标签线
    showLabelLine: {
      type: Boolean,
      default: true
    },
    // 标签线样式
    labelLineStyle: {
      type: Object,
      default: function _default() {
        return {
          color: '#ccc',
          width: 1
        };
      }
    }
  },
  computed: {
    // 饼图数据和
    dataTotal: function dataTotal() {
      return Object.values(this.chartData).reduce(function (total, current) {
        return total + current;
      }, 0);
    },
    // 图表样式
    chartStyles: function chartStyles() {
      return {
        width: this.width,
        height: this.height
      };
    },
    // 图表配置
    chartOption: function chartOption() {
      // 转换数据格式
      var seriesData = Object.entries(this.chartData).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          value = _ref2[1];
        return {
          name: name,
          value: value
          // itemStyle: {
          //   color: this.colorMap[name] || '#909399',
          // },
        };
      });
      return {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}人 ({d}%)'
        },
        legend: _objectSpread(_objectSpread({}, this.legend), {}, {
          data: seriesData.map(function (item) {
            return item.name;
          })
        }),
        color: this.colorList,
        series: [{
          name: this.seriesName,
          type: 'pie',
          radius: this.radius,
          center: this.center,
          avoidLabelOverlap: true,
          // 是否开启标签重叠处理
          itemStyle: {
            borderRadius: 8,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: this.showLabel,
            position: this.labelPosition,
            formatter: this.labelFormatter,
            fontSize: this.labelStyle.fontSize,
            color: this.labelStyle.color
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '14',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: this.showLabelLine,
            lineStyle: {
              color: this.labelLineStyle.color,
              width: this.labelLineStyle.width
            },
            length: 14,
            length2: 10
          },
          data: seriesData
        }]
      };
    }
  }
};